var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ve-ring',{attrs:{"data":_vm.materialChartData.materialChartData,"settings":_vm.chartSettings,"height":"480px","width":"480px","colors":_vm.chartColours}})}
var staticRenderFns = []

export { render, staticRenderFns }